class Assessment {
    appraisal;
    bricks;
    constructor(data) {
        this.appraisal = data.appraisal;
        this.bricks = data.bricks;
    }
}
export default Assessment;
